import { Box, Grid, Typography, Card, CardContent, CardActionArea } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CreateIcon from '@mui/icons-material/Create';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { MainUrls } from '../constants/urls';
import NotificationIconCard from './NotificationIconCard';
import NotificationAlert from './NotificationAlert';

export default function MainMenuForm(props: any) {
  return (
    <Box sx={{ p: 2 }}>
      <NotificationAlert />
      <Grid container direction={'row'} spacing={2} justifyContent={'center'}>
        <Grid item xs={12} mt={1} maxWidth={'100%'}>
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: 'repeat(2, 1fr)' }}>
            <IconCard
              title={'予約する'}
              icon={CalendarTodayIcon}
              onClick={() => {
                props.toFacilityList(MainUrls.Reservation);
              }}
              rotate={7.88}
              size={38}
            />
            <IconCard
              title={'マイページ'}
              icon={AccountCircleIcon}
              onClick={() => {
                props.setDestination({ pathname: MainUrls.Mypage });
              }}
              rotate={8.62}
              size={40}
            />
            <IconCard
              title={'医療健康情報'}
              icon={CreateIcon}
              onClick={() => {
                props.setDestination({ pathname: MainUrls.MedicalHealthInformation });
              }}
              rotate={-173.54}
              size={40}
            />
            <IconCard
              title={'QRコード'}
              icon={QrCodeScannerIcon}
              onClick={() => {
                props.toFacilityList(MainUrls.QRCode);
              }}
              rotate={15.38}
              size={38}
            />
            <NotificationIconCard
              title={'ご連絡'}
              onClick={() => {
                props.setDestination({ pathname: MainUrls.Notification });
              }}
              rotate={10.38}
              size={38}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

const IconCard = (props: { icon: any; title: string; onClick: () => void; rotate?: number; size?: number }) => {
  return (
    <Card variant="outlined">
      <CardActionArea onClick={props.onClick}>
        <CardContent sx={{ padding: '8px !important' }}>
          <Grid container direction={'row'} justifyContent={'space-between'} alignItems={'center'} m={1}>
            <Typography className="font-bold" mr={'auto'} zIndex={1}>
              {props.title}
            </Typography>
            <Grid
              m={0.5}
              py={'auto'}
              right={0}
              position={'absolute'}
              sx={{ opacity: 0.3, transform: `rotate(${props.rotate || 0}deg)` }}
            >
              <props.icon sx={{ color: '#A08B64', fontSize: props.size || 40 }} />
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
